import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import AdditionalService from "../../components/YachtClub/ViewDetails/AdditionalService";
import BoxBlueWithHeader from "../../components/YachtClub/ViewDetails/BoxBlueWithHeader";
// import OwnersDetails from "../../components/YachtClub/ViewDetails/OwnersDetails";
// import VisitDetails from "../../components/YachtClub/ViewDetails/VisitDetails";
import { StyledPageHeader } from "../../components/YachtClub/YachtClubRegistration/YachtClubRegistrationHeader";
import { Colors } from "../../config/Constants";
import { useLoadContext } from "../../contexts/LoadContext";
import {
  getYachtAdditionalServiceDetailsById,
  yachtAddServiceComplete,
} from "../../services/yachtClubService";
import {
  ActionRow,
  BackButtonWrapper,
  ButtonWrapper,
  HeaderName,
  HeaderWrapper,
} from "../YachtClubViewDetails";

const YCViewAddServiceDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({
    additionalFacility: [],
    date: "",
    time: "",
    user: {
      email: "",
      name: "",
      phone: "",
    },
    vesselLoa: 0,
  });
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [approvedOrRejected, setApprovedOrRejected] = useState("");
  const { setLoader } = useLoadContext();

  const getHistoryOrRegistration = (data: string) => {
    switch (data) {
      case "completed":
        setApprovedOrRejected("completed");
        break;
      case "pending":
        setApprovedOrRejected("pending");
        break;
      default:
        setApprovedOrRejected("processing");
        break;
    }
  };

  const fetchDetails = async () => {
    try {
      const response = await getYachtAdditionalServiceDetailsById(id);
      if (response.data.code === 200) {
        setData(response.data.data);
        getHistoryOrRegistration(response.data.data.status);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleContinue = async () => {
    setLoader(true);
    try {
      const response = await yachtAddServiceComplete(id);
      if (response.data.code === 200) {
        setLoader(false);
        navigate("/admin/yacht-club");
      }
    } catch (error: any) {
      setLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  return (
    <>
      <HeaderWrapper>
        <HeaderName>
          <StyledPageHeader>Additional Services</StyledPageHeader>
          {/* <StyledName>- {details?.name}</StyledName> */}
        </HeaderName>
        <BackButtonWrapper>
          <Button
            label="Back"
            isRounded={true}
            onClick={() => navigate("/admin/yacht-club")}
          />
        </BackButtonWrapper>
      </HeaderWrapper>
      <BoxBlueWithHeader label="Visit Details">
        {/* <VisitDetails
          visitDate={data.date}
          visitTime={data.time}
          loa={data.vesselLoa}
          isAdditionalService={true}
        /> */}
      </BoxBlueWithHeader>

      <br />

      <BoxBlueWithHeader label="Owner's Details">
        {/* <OwnersDetails
          ownerName={data.user.name}
          mobileNumber={data.user.phone}
          email={data.user.email}
          isAdditionalService={true}
        /> */}
      </BoxBlueWithHeader>

      <br />

      <BoxBlueWithHeader label="Additional Services">
        <AdditionalService additionalFacility={data.additionalFacility} />
      </BoxBlueWithHeader>

      {(approvedOrRejected === "processing" ||
        approvedOrRejected === "pending") && (
        <ActionRow>
          <ButtonWrapper>
            <Button
              variant="filled"
              label="Completed"
              width="155px"
              color={Colors.appleGreen}
              onClick={handleContinue}
            ></Button>
          </ButtonWrapper>
        </ActionRow>
      )}

      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
    </>
  );
};

export default YCViewAddServiceDetails;
